import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0f7cbe20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkbox__wrapper" }
const _hoisted_2 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "8",
  viewBox: "0 0 10 8",
  fill: "none"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10 1.5L3.5 8L1.09122e-08 4.5L1.5 3L3.5 5L8.5 -2.06119e-08L10 1.5Z",
  fill: "currentColor"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "2",
  viewBox: "0 0 10 2",
  fill: "none"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  d: "M0 0H10V2H0V0Z",
  fill: "currentColor"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "checkbox__signs"
}
const _hoisted_9 = { class: "checkbox__main-sign" }

import { computed, ref, useSlots, PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'tir-checkbox',
  props: {
  /**
   * Значение
   */
  modelValue: { type: Boolean as PropType<boolean | null>, default: null },
  /**
   * Варинант
   */
  isUnselect: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Дизейбл
   */
  isDisabled: { type: Boolean as PropType<boolean>, default: false },
  /**
   * Подсказка ошибки
   */
  isError: { type: Boolean as PropType<boolean>, default: false },
},
  emits: ["update:modelValue", "check"],
  setup(__props, { emit }) {

const props = __props;


/**
 * События
 */

/**
 * Внутреннее значение
 */
const innerValue = ref(false);

const slots = useSlots();

/**
 * Есть ли слот для лейбла текста
 */
const isWithLabel = computed(() => slots && slots.mainSign && slots.mainSign());
const isWithHintSign = computed(() => slots && slots.hintSign && slots.hintSign());
/**
 * Значение
 */
const value = computed({
  get: () => (props.modelValue == null ? innerValue.value : props.modelValue),
  set: (value: boolean) => {
    emit("update:modelValue", value);
    innerValue.value = value;
    emit("check", value);
  },
});

/**
 * При клике
 */

const onCheck = () => {
  if (props.isDisabled) return;
  value.value = !value.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["checkbox", { 'checkbox--disabled': __props.isDisabled }]),
    onClick: onCheck
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["checkbox__inner-icon", { 'checkbox__inner-icon--check': value.value}])
      }, [
        (!props.isUnselect)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_2, _hoisted_4))
          : _createCommentVNode("", true),
        (props.isUnselect)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_5, _hoisted_7))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    (isWithLabel.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, [
            _renderSlot(_ctx.$slots, "mainSign")
          ]),
          (isWithHintSign.value)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["checkbox__hint-sign", {
          'checkbox__hint-sign--error': props.isError,
        }])
              }, [
                _renderSlot(_ctx.$slots, "hintSign")
              ], 2))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})